import React from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { toast } from "react-toastify";
import {
  addFileStep2,
  deleteAttachmentOfFile,
  uploadAttachmentOfFile,
} from "../../actions/FileAction";
import { getDepartmentList } from "../../actions/MasterAction";
import { getApprovingAuthority } from "../../actions/UserAction";
import TextEditor from "../../component/common/TextEditor2";

// Import pdfjs
import * as pdfjsLib from "pdfjs-dist";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";

const addFooterToPDF = async (pdfFile, empCode, fileCode,empName) => {
  try {
    const existingPdfBytes = await pdfFile.arrayBuffer();
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const pages = pdfDoc.getPages();
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const fontSize = 10;

    pages.forEach((page, index) => {
      const { width, height } = page.getSize();
      const now = new Date();
      // const todayDateTime = now.toISOString().replace("T", " ").split(".")[0];
      const todayDateTime = new Date().toLocaleString();
      // const footerText = `Emp Code: ${empCode} | File Number: ${fileCode} | ${todayDateTime}`;
      // const textWidth = font.widthOfTextAtSize(footerText, fontSize);
      const footerText = empName 
        ? `Emp Code: ${empCode} | Name: ${empName} | File Number: ${fileCode} | ${todayDateTime}`
        : `Emp Code: ${empCode} | File Number: ${fileCode} | ${todayDateTime}`;
      const textWidth = font.widthOfTextAtSize(footerText, fontSize);

      page.drawText(footerText, {
        x: (width - textWidth) / 2,
        y: 20,
        size: fontSize,
        font: font,
        color: rgb(0, 0, 0),
      });

      page.drawLine({
        start: { x: 50, y: 30 },
        end: { x: width - 50, y: 30 },
        thickness: 1,
        color: rgb(0, 0, 0),
      });
    });

    const modifiedPdfBytes = await pdfDoc.save();
    return new File([modifiedPdfBytes], pdfFile.name, {
      type: "application/pdf",
    });
  } catch (error) {
    console.error("Error adding footer:", error);
    throw error;
  }
};

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const extractPageCountFromPDF = async (file) => {
  if (file.type !== "application/pdf") {
    return 1;
  }

  try {
    return new Promise((resolve) => {
      const reader = new FileReader();

      reader.onload = async (e) => {
        try {
          const arrayBuffer = e.target.result;
          const pdf = await pdfjsLib.getDocument({
            data: arrayBuffer,
            verbosity: 0,
          }).promise;
          resolve(pdf.numPages);
        } catch (error) {
          console.warn(
            `Could not read PDF page count for ${file.name}:`,
            error
          );
          resolve(1);
        }
      };

      reader.onerror = () => {
        console.warn(`Error reading file ${file.name}`);
        resolve(1);
      };

      reader.readAsArrayBuffer(file);
    });
  } catch (error) {
    console.error("PDF extraction error:", error);
    return 1;
  }
};

class FileDetailsStep2 extends React.Component {
  constructor(props) {
    super(props);

    const initialData = props.initialData || {};

    this.state = {
      attachments: {
        name: "attachments",
        value: initialData.attachments || [],
        error: "",
        isRequired: true,
      },

      approvingAuthority: {
        value: [], // ✅ Start with empty array
        options: [], // ✅ Initialize as empty array
        error: "",
        isRequired: true,
      },
      to: {
        name: "to",
        value: [],
        error: "",
        isRequired: true,
        options: props.recipients || [],
      },
      department: {
        name: "department",
        value: [],
        error: "",
        isRequired: false,
        options: props.departmentOptions || [],
      },
      body: {
        name: "body",
        value: initialData.purposal || "",
        error: "",
        isRequired: true,
      },
      sheetType: {
        name: "sheetType",
        value: initialData.sheetType || "green",
        error: "",
      },

      uploadedFiles: initialData.attachments || [],
      showLoader: false,
      currentPdfInfo: null,
      selectedText: "",
      showPageSelector: false,
      selectedPage: null,
      isExtractingPages: false,
    };
  }

  async componentDidMount() {
    try {
      const [authRes, deptRes] = await Promise.all([
        getApprovingAuthority(),
        getDepartmentList(),
      ]);

      const initialData = this.props.initialData || {};

      // ✅ Helper function to find matching option
      const findMatchingOptions = (options, value) => {
        if (!value) return [];
        if (Array.isArray(value)) {
          return value
            .map((v) => {
              if (typeof v === "object" && v.code) return v;
              return options.find((opt) => opt.code === v) || null;
            })
            .filter(Boolean);
        }
        if (typeof value === "object" && value.code) return [value];
        return options.filter((opt) => opt.code === value);
      };

      this.setState((prevState) => ({
        approvingAuthority: {
          ...prevState.approvingAuthority,
          options: authRes.result || [],
          value: findMatchingOptions(
            authRes.result || [],
            initialData.approvingAuthority
          ),
        },
        department: {
          ...prevState.department,
          options: deptRes.result || [],
          value: findMatchingOptions(
            deptRes.result || [],
            initialData.department
          ),
        },
        to: {
          ...prevState.to,
          value: findMatchingOptions(prevState.to.options, initialData.to),
        },
      }));
    } catch (error) {
      console.error("Error loading data:", error);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.initialData !== prevProps.initialData &&
      this.props.initialData
    ) {
      const initialData = this.props.initialData;

      // ✅ Helper function to find matching option
      const findMatchingOptions = (options, value) => {
        if (!value) return [];
        if (Array.isArray(value)) {
          return value
            .map((v) => {
              if (typeof v === "object" && v.code) return v;
              return options.find((opt) => opt.code === v) || null;
            })
            .filter(Boolean);
        }
        if (typeof value === "object" && value.code) return [value];
        return options.filter((opt) => opt.code === value);
      };

      this.setState((prevState) => ({
        attachments: {
          ...prevState.attachments,
          value: initialData.attachments || [],
        },
        approvingAuthority: {
          ...prevState.approvingAuthority,
          value: findMatchingOptions(
            prevState.approvingAuthority.options,
            initialData.approvingAuthority
          ),
        },
        to: {
          ...prevState.to,
          value: findMatchingOptions(prevState.to.options, initialData.to),
        },
        department: {
          ...prevState.department,
          value: findMatchingOptions(
            prevState.department.options,
            initialData.department
          ),
        },
        body: {
          ...prevState.body,
          value: initialData.purposal || initialData.body || "",
        },
        sheetType: {
          ...prevState.sheetType,
          value: initialData.sheetType || "green",
        },
        uploadedFiles: initialData.attachments || [],
      }));
    }
  }

  handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    // 🔥 Allow only PDF files
    const invalidFiles = files.filter(
      (file) => file.type !== "application/pdf"
    );

    if (invalidFiles.length > 0) {
      toast.error("Only PDF files are allowed.");
      e.target.value = null;
      return;
    }

    if (!files.length) return;

    if (
      !this.state.department.value ||
      this.state.department.value.length === 0
    ) {
      toast.error("Please select department first before uploading files");
      e.target.value = null;
      return;
    }

    const deptCode = this.state.department.value[0]?.code;

    if (!deptCode) {
      toast.error("Invalid department selected");
      e.target.value = null;
      return;
    }

    const fileCode = this.props.fileCode;
    const empCode = this.props.userDetail?.employeeNumber;
    const empName = this.props.userDetail?.name;

    this.setState({ showLoader: true, isExtractingPages: true });

    try {
      for (const file of files) {
        let fileToUpload = file;

        if (file.type === "application/pdf") {
          try {
            this.setState({ isAddingFooter: true });
            fileToUpload = await addFooterToPDF(file, empCode, fileCode,empName);
          } catch (footerError) {
            console.warn(
              "Could not add footer, using original file:",
              footerError
            );
          } finally {
            this.setState({ isAddingFooter: false });
          }
        }

        const pageCount = await extractPageCountFromPDF(fileToUpload);

        const model = {
          fileCode: fileCode.toString(),
          deptCode: deptCode.toString(),
          pageCount: pageCount,
          fileUploadModel: "pdfjs-extractor-v1",
          fileName: fileToUpload.name,
          fileType: fileToUpload.type,
          fileSize: fileToUpload.size,
          attachment: fileToUpload,
        };

        const uploadRes = await uploadAttachmentOfFile(model);

        if (uploadRes.status === "success" || uploadRes.result) {
          const uploadedFile = {
            ...uploadRes.result,
            originalName: file.name,
            modifiedName: fileToUpload.name,
            fileSize: fileToUpload.size,
            uploadDate: new Date().toISOString(),
            fileCode: fileCode,
            deptCode: deptCode,
            pageCount: pageCount,
            fileType: fileToUpload.type,
            previewUrl: `${
              process.env.REACT_APP_BASE_URL
            }attachment/${fileCode}/${
              uploadRes.result.fileName || fileToUpload.name
            }`.replace("v1/", ""),
            hasFooter: file.type === "application/pdf",
          };

          this.setState((prevState) => ({
            uploadedFiles: [...prevState.uploadedFiles, uploadedFile],
          }));

          toast.success(
            `${file.name} uploaded successfully (${pageCount} pages${
              file.type === "application/pdf" ? " with footer" : ""
            })`
          );
        } else {
          const errorMsg =
            uploadRes.error || uploadRes.message || "Upload failed";
          toast.error(`Failed to upload ${file.name}: ${errorMsg}`);
        }
      }
    } catch (error) {
      console.error("Upload catch error:", error);
      toast.error(`Error uploading files: ${error.message}`);
    } finally {
      this.setState({
        showLoader: false,
        isExtractingPages: false,
        isAddingFooter: false,
      });
    }
  };

  handleDeleteFile = async (file, index) => {
    const { fileCode } = this.props;
    const model = {
      fileCode: fileCode,
      originalFileName: file.originalFileName,
      fileName: file.fileName,
    };

    this.setState({ showLoader: true });

    const res = await deleteAttachmentOfFile(model);
    if (res.status === "success") {
      this.setState((prev) => ({
        uploadedFiles: prev.uploadedFiles.filter((_, i) => i !== index),
      }));

      toast.success("File deleted");
    } else {
      toast.error(res.error || "Failed to delete file");
    }

    this.setState({ showLoader: false });
  };

  handleFilePreview = (file, pageNumber = 1) => {
    const fileUrl =
      `${process.env.REACT_APP_BASE_URL}attachment/${file.fileCode}/${file.fileName}`.replace(
        "v1/",
        ""
      );
    const pdfUrlWithPage =
      pageNumber > 1 ? `${fileUrl}#page=${pageNumber}` : fileUrl;

    this.setState({
      currentPdfInfo: {
        url: pdfUrlWithPage,
        fileName: file.fileName,
        pageCount: file.pageCount || 1,
        fileCode: file.fileCode,
        originalName: file.originalName,
        currentPage: pageNumber,
      },
      showPageSelector: false,
      selectedPage: pageNumber,
    });
  };

  handlePageChange = (pageNumber) => {
    if (!this.state.currentPdfInfo) return;

    const { currentPdfInfo } = this.state;
    const fileUrl =
      `${process.env.REACT_APP_BASE_URL}attachment/${currentPdfInfo.fileCode}/${currentPdfInfo.fileName}`.replace(
        "v1/",
        ""
      );
    const pdfUrlWithPage =
      pageNumber > 1 ? `${fileUrl}#page=${pageNumber}` : fileUrl;
  };

  handleTextSelect = (selectedText) => {
    if (selectedText && this.state.currentPdfInfo) {
      this.setState({
        selectedText,
        showPageSelector: true,
      });
    }
  };

  createReferenceLink = () => {
    const { selectedText, currentPdfInfo, selectedPage } = this.state;
    if (!selectedText || !currentPdfInfo) return;

    const page = selectedPage || 1;
    const fileUrl =
      `${process.env.REACT_APP_BASE_URL}attachment/${currentPdfInfo.fileCode}/${currentPdfInfo.fileName}`.replace(
        "v1/",
        ""
      );
    const link = `${fileUrl}#page=${page}`;
    const linkHtml = `<a href="${link}" target="_blank" data-file="${currentPdfInfo.fileName}" data-page="${page}">${selectedText}</a>`;

    window.dispatchEvent(
      new CustomEvent("insertLinkToEditor", {
        detail: {
          html: linkHtml,
          text: selectedText,
          link: link,
          page: page,
          fileName: currentPdfInfo.originalName,
        },
      })
    );

    this.setState({
      showPageSelector: false,
      selectedText: "",
    });

    toast.success(
      `Linked "${selectedText.substring(0, 30)}..." to page ${page}`
    );
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: {
        ...prevState[name],
        value: value,
        error: "",
      },
    }));
  };

  handleTypeaheadChange = (name, value) => {
    this.setState((prevState) => ({
      [name]: {
        ...prevState[name],
        value: value,
        error: "",
      },
    }));
  };

  validateStep = () => {
    const { to, department } = this.state;
    let isValid = true;

    if (to.value.length === 0) {
      this.setState((prevState) => ({
        to: { ...prevState.to, error: "Recipient is required" },
      }));
      isValid = false;
    }

    if (department.value.length === 0) {
      this.setState((prevState) => ({
        department: {
          ...prevState.department,
          error: "Department is required",
        },
      }));
      isValid = false;
    }

    if (this.state.uploadedFiles.length === 0) {
      this.setState((prevState) => ({
        attachments: {
          ...prevState.attachments,
          error: "At least one file is required",
        },
      }));
      isValid = false;
    }

    return isValid;
  };

  handleComplete = async () => {
    if (!this.validateStep()) {
      return;
    }

    const { body, to, department, approvingAuthority, sheetType } = this.state;

    const stepData = {
      approvingAuthority: Array.isArray(approvingAuthority.value)
        ? approvingAuthority.value[0]?.code || approvingAuthority.value[0]
        : approvingAuthority.value?.code || approvingAuthority.value,
      to: to.value,
      department: Array.isArray(department.value)
        ? department.value.map((item) => item.code || item)
        : [department.value?.code || department.value],
      purposal: body.value,
      sheetType: sheetType.value,
    };

    const { fileCode } = this.props;

    if (!fileCode) {
      toast.error("File code is missing. Please go back to step 1.");
      return;
    }

    this.setState({ showLoader: true });

    try {
      const response = await addFileStep2(fileCode, stepData);

      if (response.success || response.status === "success") {
        toast.success("Step 2 completed successfully!");
        this.props.onStepComplete({ stepData });
      } else {
        const errorMsg =
          response.message || response.error || "Failed to save step 2";
        toast.error(`Error: ${errorMsg}`);
      }
    } catch (error) {
      console.error("Error in handleComplete:", error);
      toast.error(`Failed to save: ${error.message || "Unknown error"}`);
    } finally {
      this.setState({ showLoader: false });
    }
  };

  render() {
    const {
      body,
      to,
      department,
      approvingAuthority,
      sheetType,
      attachments,
      uploadedFiles,
      currentPdfInfo,
      showPageSelector,
      selectedText,
      selectedPage,
      showLoader,
      isExtractingPages,
    } = this.state;

    return (
      <div className="step-content">
        <h5 className="mb-4">Step 2: File Details & Upload</h5>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group mb-3">
              <label>
                Approving authority <small className="text-danger">*</small>
              </label>
              <Typeahead
                id="ta-approving-authority"
                multiple={false}
                labelKey={(option) =>
                  `${option.name} - ${option.employeeNumber}`
                }
                options={approvingAuthority.options || []}
                selected={approvingAuthority.value || []}
                onChange={(selected) =>
                  this.handleTypeaheadChange("approvingAuthority", selected)
                }
                placeholder="Select Approver"
                isInvalid={!!approvingAuthority.error}
              />
              {approvingAuthority.error && (
                <div className="text-danger small">
                  {approvingAuthority.error}
                </div>
              )}
            </div>

            <div className="form-group mb-3">
              <label>
                Recipient <small className="text-danger">*</small>
              </label>
              <Typeahead
                id="ta-recipient"
                multiple={false}
                labelKey={(option) =>
                  `${option.name} - ${option.employeeNumber}`
                }
                options={to.options || []}
                selected={to.value || []}
                onChange={(selected) =>
                  this.handleTypeaheadChange("to", selected)
                }
                placeholder="Select recipient"
                isInvalid={!!to.error}
              />
              {to.error && <div className="text-danger small">{to.error}</div>}
            </div>

            <div className="form-group mb-3">
              <label>
                Select Department <small className="text-danger">*</small>
              </label>
              <Typeahead
                id="ta-department"
                labelKey="name"
                multiple={false}
                maxResults={5}
                options={department.options || []}
                selected={department.value || []}
                onChange={(selected) =>
                  this.handleTypeaheadChange("department", selected)
                }
                placeholder="Select department"
                isInvalid={!!department.error}
              />
              <small className="text-muted">
                Department must be selected before file upload
              </small>
              {department.error && (
                <div className="text-danger small">{department.error}</div>
              )}
            </div>

            <div className="form-group mb-3">
              <label>
                File(s) <small className="text-danger">*</small>
              </label>
              <input
                type="file"
                className={`form-control ${attachments.error ? "is-invalid" : ""
                  }`}
                onChange={this.handleFileChange}
                multiple
                disabled={showLoader || !department.value.length}
                accept=".pdf,application/pdf"
              />
              {!department.value.length && (
                <div
                  className="alert alert-warning mt-2 py-1"
                  style={{ fontSize: "0.85rem" }}
                >
                  Please select department first to enable file upload
                </div>
              )}
              {attachments.error && (
                <div className="invalid-feedback">{attachments.error}</div>
              )}
              {showLoader && (
                <div className="mt-2">
                  <div
                    className="spinner-border spinner-border-sm text-primary me-2"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  {isExtractingPages
                    ? "Extracting page count..."
                    : "Uploading files..."}
                </div>
              )}
            </div>

            {uploadedFiles.length > 0 && (
              <div className="mb-3">
                <small className="text-muted d-block mb-2">
                  Uploaded files (click to preview):
                </small>

                <div
                  className="list-group"
                  style={{ maxHeight: "200px", overflowY: "auto" }}
                >
                  {uploadedFiles.map((file, index) => (
                    <div
                      key={index}
                      className="list-group-item d-flex justify-content-between align-items-center py-2"
                    >
                      <button
                        type="button"
                        className="btn btn-link p-0 text-start"
                        onClick={() => this.handleFilePreview(file)}
                      >
                        <small
                          className="text-truncate"
                          style={{ maxWidth: "200px" }}
                        >
                          {file.originalFileName || file.originalName}
                        </small>
                      </button>

                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => this.handleDeleteFile(file, index)}
                      >
                        Delete
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="form-group mb-3">
              <div className="mb-2">
                <label>
                  Proposal <small className="text-danger">*</small>
                </label>
                <div className="btn-group btn-group-sm">
                  <button
                    type="button"
                    className={`btn ${
                      sheetType.value === "yellow"
                        ? "btn-warning"
                        : "btn-outline-warning"
                    }`}
                    onClick={() =>
                      this.setState((prevState) => ({
                        sheetType: { ...prevState.sheetType, value: "yellow" },
                      }))
                    }
                  >
                    Yellow Sheet
                  </button>
                  <button
                    type="button"
                    className={`btn ${
                      sheetType.value === "green"
                        ? "btn-success"
                        : "btn-outline-success"
                    }`}
                    onClick={() =>
                      this.setState((prevState) => ({
                        sheetType: { ...prevState.sheetType, value: "green" },
                      }))
                    }
                  >
                    Green Sheet
                  </button>
                </div>
              </div>

              <TextEditor
                error={body.error}
                name={body.name}
                value={body.value}
                onChange={this.handleChange}
                onTextSelect={this.handleTextSelect}
                placeholder="Enter proposal details..."
                bgColor={sheetType.value === "green" ? "#C8E6C9" : "#FFF9C4"}
              />
              {body.error && (
                <div className="text-danger small">{body.error}</div>
              )}
            </div>

            {showPageSelector && currentPdfInfo && selectedText && (
              <div className="alert alert-info p-2 mb-3">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <span className="me-2">
                      Selected text: "{selectedText.substring(0, 30)}..."
                    </span>
                    <span className="badge bg-secondary me-2">
                      File: {currentPdfInfo.originalName}
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Page:</span>
                    <select
                      className="form-select form-select-sm me-2"
                      style={{ width: "100px" }}
                      value={selectedPage || currentPdfInfo.currentPage || 1}
                      onChange={(e) =>
                        this.setState({
                          selectedPage: parseInt(e.target.value),
                        })
                      }
                    >
                      {[...Array(currentPdfInfo.pageCount)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                          Page {i + 1}
                        </option>
                      ))}
                    </select>
                    <button
                      type="button"
                      className="btn btn-sm btn-success me-1"
                      onClick={this.createReferenceLink}
                    >
                      Create Link
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() =>
                        this.setState({
                          showPageSelector: false,
                          selectedText: "",
                        })
                      }
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-md-6">
            {currentPdfInfo ? (
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center py-2">
                  <div className="d-flex align-items-center">
                    <h6
                      className="mb-0 me-3 text-truncate"
                      style={{ maxWidth: "250px" }}
                    >
                      {currentPdfInfo.originalName}
                    </h6>
                    <div className="d-flex align-items-center">
                      <span className="badge bg-light text-dark me-2">
                        Page {currentPdfInfo.currentPage || 1} of{" "}
                        {currentPdfInfo.pageCount}
                      </span>
                      <select
                        className="form-select form-select-sm"
                        style={{ width: "100px" }}
                        value={currentPdfInfo.currentPage || 1}
                        onChange={(e) =>
                          this.handlePageChange(parseInt(e.target.value))
                        }
                      >
                        {[...Array(currentPdfInfo.pageCount)].map((_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => this.setState({ currentPdfInfo: null })}
                  >
                    Close
                  </button>
                </div>
                <div className="card-body p-0">
                  <iframe
                    src={currentPdfInfo.url}
                    style={{ width: "100%", height: "80vh", border: "none" }}
                    title="PDF Preview"
                  ></iframe>
                </div>
              </div>
            ) : (
              <div className="card h-100">
                <div className="card-body d-flex align-items-center justify-content-center">
                  <div className="text-center text-muted">
                    <i
                      className="bi bi-file-earmark-pdf"
                      style={{ fontSize: "3rem" }}
                    ></i>
                    <p className="mt-2">No PDF selected for preview</p>
                    <small>Click on an uploaded file to preview it here</small>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-md-12 mt-4">
            <div className="d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.handleComplete}
                disabled={showLoader || uploadedFiles.length === 0}
              >
                {showLoader ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  "Save & Continue"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FileDetailsStep2;
